import { createContext } from 'react'
import { RouteComponentProps } from 'react-router-dom'

export interface TRouterContextProvider extends RouteComponentProps {
  children?: React.ReactNode
  prefix?: string
}
export interface TContextValue extends TRouterContextProvider {
  prefix?: string | undefined
  pathname?: string
  appendUrl?: (url: string) => void
  replaceUrl?: (needle: string, w: string) => void
}

const RouterContext = createContext<TContextValue | null>(null)

export default RouterContext
